module.exports = __webpack_public_path__ + "img/gbmg_snb.db88acb1.svg";